import { reverse } from "@reactivated";

import { FormTokenResponse, check } from "../models";

const RETRY_DELAYS_MS = [1000, 3000];

export const sleep = (durationMs: number): Promise<void> =>
    new Promise((resolve) => setTimeout(resolve, durationMs));

const fetchFormToken = async (): Promise<string> => {
    const resp = await fetch(reverse("cms-api:form-token"));
    const data = (await resp.json()) as unknown;
    return check(FormTokenResponse.decode(data)).token;
};

const fetchFormTokenWithRetries = async (): Promise<string> => {
    for (const delayMs of RETRY_DELAYS_MS) {
        try {
            return await fetchFormToken();
        } catch {
            await sleep(delayMs);
        }
    }
    return fetchFormToken();
};

let pendingFormToken: Promise<string> | null = null;

/**
 * Load the signed timestamp token used by the time-to-submit spam check.
 * Retries transient failures so a network blip doesn't cost the submission
 * its token. The token isn't form-specific, so one fetch is shared by all
 * forms on the page; a failed fetch clears the shared promise so a later
 * attempt can try again.
 */
export const loadFormToken = (): Promise<string> => {
    pendingFormToken ??= fetchFormTokenWithRetries().catch((error: unknown) => {
        pendingFormToken = null;
        throw error;
    });
    return pendingFormToken;
};
